// Import '../../../../wwwroot/css/bundle.min.css'

import { createSSRApp } from 'vue'
import { createPinia } from 'pinia'
import App from './App.vue'

// Disable console output in production
if (typeof window !== 'undefined' && window.__ENV__ === 'production') {
  const noop = () => {}
  console.log = noop
  console.warn = noop
  console.debug = noop
  console.info = noop
}

// Performance monitoring
if (typeof window !== 'undefined') {
  if ('performance' in window) {
    window.addEventListener('load', () => {
      const perfData = performance.getEntriesByType('navigation')[0]
      console.log('Page load time:', perfData.loadEventEnd - perfData.loadEventStart, 'ms')
    })
  }
}

export function createApp() {
  const app = createSSRApp(App)
  const pinia = createPinia()

  // Hydrate Pinia state from SSR
  if (typeof window !== 'undefined' && window.__PINIA_INITIAL_STATE__) {
    pinia.state.value = window.__PINIA_INITIAL_STATE__
  }

  app.use(pinia)

  return { app, pinia }
}
